import { render, staticRenderFns } from "./NotificationDropdownReport.vue?vue&type=template&id=101b3fdc"
import script from "./NotificationDropdownReport.vue?vue&type=script&lang=js"
export * from "./NotificationDropdownReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports